import axios from "axios";
import { MemberTaskCount } from "../../types";
import { Policy, PolicyInfo } from "../policyIssues/types";
import { countAndMapAssignedTasks } from "./commonUtils";

export const getPoliciesToSendUniqueAssignedToList = (policiesToSend: Policy[]): MemberTaskCount[] =>
  countAndMapAssignedTasks(policiesToSend, "Policies To Send");

export const searchPoliciesToSend = async () => {
  const { data } = await axios.get<Policy[]>("/api/OutstandingChecks/GetPoliciesToSendForDashboard");
  return data.filter((f) => f.status !== 3);
};

export const fetchPolicyInfoByOrderNumber = async (orderNumber: string | null | undefined): Promise<PolicyInfo[]> => {
  if (!orderNumber) {
    throw new Error("Order number is required to fetch policies.");
  }

  const { data } = await axios.get<PolicyInfo[]>(`/proxy/api/orders/getpolicies?orderNumber=${orderNumber}`);
  return data;
};
